import { ReactNode } from 'react';
import { Flex } from '../grid';
import { Icon, IconProps } from '../icon';

export type NavbarVerticalMenuItemProps = {
  icon?: IconProps['icon'];
  label: ReactNode;
  externalTarget?: boolean;
};

export const NavbarVerticalMenuItem = ({
  icon,
  label,
  externalTarget,
}: NavbarVerticalMenuItemProps) => {
  return (
    <Flex alignItems='center'>
      {icon && (
        <span className='nav-link-icon'>
          <Icon icon={icon} width={20} height={20} />
        </span>
      )}
      <Flex className='w-100' justifyContent='between'>
        <span className='nav-link-text ps-1'>{label}</span>
        {externalTarget && <Icon icon={'share-box'} width={20} height={20} />}
      </Flex>
    </Flex>
  );
};
